import { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import type { SxProps, Theme } from '@mui/material/styles';
import LanguageIcon from '@mui/icons-material/Language';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES, DEFAULT_LANGUAGE } from '../i18n/languages';

type LanguageMenuProps = {
  sx?: SxProps<Theme>;
};

export function LanguageMenu({ sx }: LanguageMenuProps) {
  const { t, i18n } = useTranslation();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const current = i18n.resolvedLanguage ?? DEFAULT_LANGUAGE;

  const choose = (language: string) => {
    i18n.changeLanguage(language);
    setAnchor(null);
  };

  return (
    <>
      <Button
        size="small"
        color="inherit"
        sx={sx}
        startIcon={<LanguageIcon />}
        endIcon={<ArrowDropDownIcon />}
        aria-haspopup="menu"
        aria-expanded={anchor ? true : undefined}
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        {t(`languages.${current}`)}
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        // The trigger sits in the footer, so the list opens upwards rather than
        // off the bottom of the page.
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        {SUPPORTED_LANGUAGES.map((language) => (
          <MenuItem
            key={language}
            selected={language === current}
            onClick={() => choose(language)}
          >
            {t(`languages.${language}`)}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
